import twoDigitFormat from "./two.digit.format";

const months = [

  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",

]

const formatDate = ( dateString, withTime = false ) => {

  const d = new Date( dateString );
  if ( !d?.getDate() ) { return 'Некорректная дата' }

  let date = `${ twoDigitFormat( d.getDate() ) } ${ months[ d.getMonth() ] } ${ d.getFullYear() }`;

  if ( withTime ) {
    date += ` ${ twoDigitFormat( d.getHours() ) }:${ twoDigitFormat( d.getMinutes() ) }`;
  }
  
  return ( date );

}

export {

  formatDate

}